import {
  put, takeLatest, all, takeEvery,
} from 'redux-saga/effects';
import { notification } from 'antd';
import AddressActions, { addressActionTypes } from '@Actions/addressActions';
import TrackerActions from '@Actions/trackerActions';
import AddressServices from '@Services/addressServices';

/**
 * @param action
 */
function* _getAddresses(action) {
  try {
    yield put(AddressActions.getAddressesLoading(true));
    const addresses = yield AddressServices.getAddresses(action?.page, action?.entityId, action?.entityType, action?.addressId);
    yield put(AddressActions.getAddressesSuccess({ addresses: addresses?.address?.addresses, type: action?.entityType }));
    yield put(AddressActions.getAddressesLoading(false));
  } catch (error) {
    yield put(AddressActions.getAddressesLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(addressActionTypes.GET_ADDRESSES.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getAddresses() {
  yield takeEvery(addressActionTypes.GET_ADDRESSES.REQUEST, _getAddresses);
}

/**
 * @param action
 */
function* _createAddress(action) {
  try {
    yield put(AddressActions.createAddressLoading(true));
    const address = yield AddressServices.createAddress(action?.payload);
    if (address.success) {
      yield put(TrackerActions.trackAction(addressActionTypes.CREATE_ADDRESS.SUCCESS, {
        request: action.payload,
        response: address,
      }));
      notification.open({
        type: 'success',
        message: 'Address Successfully added',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(address.address);
      }
    } else {
      notification.open({
        type: 'error',
        message: address.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(AddressActions.createAddressLoading(false));
  } catch (error) {
    yield put(AddressActions.createAddressLoading(false));
    yield put(TrackerActions.trackAction(addressActionTypes.CREATE_ADDRESS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 * @param action
 */
function* _updateAddress(action) {
  try {
    yield put(AddressActions.updateAddressLoading(true));
    const address = yield AddressServices.updateAddress(action?.payload);
    if (address.success) {
      yield put(TrackerActions.trackAction(addressActionTypes.UPDATE_ADDRESS.SUCCESS, {
        request: action?.payload,
        response: address,
      }));
      notification.open({
        type: 'success',
        message: 'Address Successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(address.address);
      }
    } else {
      notification.open({
        type: 'error',
        message: address.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(AddressActions.updateAddressLoading(false));
  } catch (error) {
    yield put(AddressActions.updateAddressLoading(false));
    yield put(TrackerActions.trackAction(addressActionTypes.UPDATE_ADDRESS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateAddress() {
  yield takeLatest(addressActionTypes.UPDATE_ADDRESS.REQUEST, _updateAddress);
}

/**
 *
 */
function* createAddress() {
  yield takeLatest(addressActionTypes.CREATE_ADDRESS.REQUEST, _createAddress);
}

/**
 *
 */
export default function* addressSaga() {
  yield all([
    getAddresses(),
    createAddress(),
    updateAddress(),
  ]);
}
